<template>
  <div class="achievement-section sweet-section">
    <div class="main-container">
      <div class="title-container">
        <h2>{{ t("home.sweetprotein.title") }}</h2>
      </div>

      <div class="subtitle">
        <p>{{ t("home.sweetprotein.argsubtitle1") }}</p>
      </div>

      <div class="cards-container">
        <div class="card card-1" :class="{ active: activeCard === 1 }" @mouseenter="handleCardHover(1)">
          <div class="card-background">
            <img src="@/assets/image/home/home_sweet_1_normal.png" :alt="$t('home.sweetprotein.card1Alt')" class="bg-image small-img" />
            <img src="@/assets/image/home/home_sweet_1.png" :alt="$t('home.sweetprotein.card1Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.sweetprotein.card1Title") }}</h3>
              <p>{{ $t("home.sweetprotein.card1Desc") }}</p>
            </div>
          </div>
        </div>

        <div class="card card-2" :class="{ active: activeCard === 2 }" @mouseenter="handleCardHover(2)">
          <div class="card-background">
            <img src="@/assets/image/home/home_sweet_2_normal.png" :alt="$t('home.product.card2Alt')" class="bg-image small-img" />
            <img src="@/assets/image/home/home_sweet_2.png" :alt="$t('home.product.card2Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.sweetprotein.card2Title") }}</h3>
              <p>{{ $t("home.sweetprotein.card2Desc") }}</p>
            </div>
          </div>
        </div>

        <div class="card card-3" :class="{ active: activeCard === 3, 'en-height': locale === 'en' }" @mouseenter="handleCardHover(3)" ref="cardRef">
          <div class="card-background">
            <img src="@/assets/image/home/home_sweet_3_normal.png" :alt="$t('product.card3Alt')" class="bg-image small-img" />
            <img src="@/assets/image/home/home_sweet_3.png" :alt="$t('product.card3Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.sweetprotein.card3Title") }}</h3>
              <p>{{ $t("home.sweetprotein.card3Desc") }}</p>
            </div>
          </div>
        </div>

        <div class="card card-4" :class="{ active: activeCard === 4 }" @mouseenter="handleCardHover(4)">
          <div class="card-background">
            <img src="@/assets/image/home/home_sweet_4_normal.png" :alt="$t('home.product.card4Alt')" class="bg-image small-img" />
            <img src="@/assets/image/home/home_sweet_4.png" :alt="$t('home.product.card4Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.sweetprotein.card4Title") }}</h3>
              <p>{{ $t("home.sweetprotein.card4Desc") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";

const { locale, t } = useI18n();
const activeCard = ref(1);
const cardRef = ref(null);

const handleCardHover = (cardId) => {
  activeCard.value = cardId;
};

onMounted(() => {
  activeCard.value = 1; // 初始化为第一个卡片
  updateCardHeight(); // 更新样式
});

watch(locale, updateCardHeight);

function updateCardHeight() {
  if (cardRef.value) {
    if (locale.value === 'en') {
      cardRef.value.classList.add('en-height');
    } else {
      cardRef.value.classList.remove('en-height');
    }
  }
}
</script>

<style scoped>
@import "@/assets/css/product.css";

.card {
  height: 20rem;
}
.card.active {
  height: 30rem;
}

.card-3.active {
  height: 35rem;
}

.en-height {
  height: 20rem;
}
</style>